import Components from "../components";

class SourceMapTest extends Components.Base {
  initialize() {
    this.$submit = this.$el.find("input[type=submit]");
    this.submitVal = this.$submit.val();
    this.$result = this.$el.find(".source-map-test-result");
  }

  bind() {
    this.on("push-state", (...args) => this.onPushState(...args));
    this.on("push-timeout", () => this.onPushTimeout());
    this.on("submit", "form", () => this.onFormSubmit());
    this.on("ajax:error", "form", () => this.onFormError());
  }

  onFormSubmit() {
    this.activeTimeout = setTimeout(
      () => this.$el.trigger("push-timeout"),
      5000,
    );
    this.$submit
      .addClass("disabled")
      .attr("disabled", true)
      .val("Processing...");
  }

  onFormError() {
    this.resetForm();
    this.$result.html(
      this.renderAlert("An unknown error occurred; we have been notified."),
    );
  }

  onPushTimeout() {
    this.$result.html(
      this.renderAlert(
        "The server is taking a while to respond... If this doesn't update, try refreshing the page.",
        "warning",
      ),
    );
  }

  onPushState(e, params) {
    this.resetForm();
    this.$result.html(
      params.error ? this.renderAlert(params.error) : this.render(params),
    );
  }

  resetForm() {
    clearTimeout(this.activeTimeout);
    this.$submit
      .removeClass("disabled")
      .attr("disabled", false)
      .val(this.submitVal);
  }

  render(line) {
    const file = line.file;
    const filename = line.file.split(/[\\/]/).pop();
    const method = line.method || "unknown";
    const number = line.number;
    const column = line.column;

    return `\
      <div class="c-backtrace" style="margin-bottom: 1rem;">
        <ul>
          <li class="line">
            <div class="summary-path">
              <span class="source-file">${filename}</span>
              <i class="fa fa-caret-right"></i>
              <span class="number">${number}</span>
              <i class="fa fa-caret-right"></i>
              <span class="number">${column}</span>
              <i class="fa fa-caret-right"></i>
              <span class="method">${method}(...)</span>
            </div>
            <div class="full-path">
              <a href="${
                line.file
              }">${file}</a>:${number}:${column}:in \`${method}'
            </div>
          </li>
        </ul>
      </div>\
      `;
  }

  renderAlert(message, level) {
    return `\
      <div class="alert alert-${
        level || "danger"
      }" role="alert">${message}</div>\
    `;
  }
}

Components.collection.register({
  selector: ".c-source-map-test",
  klass: SourceMapTest,
});
